module.exports = __webpack_public_path__ + "img/invoice.6f5f8137.png";